import { useState, useEffect } from "react";
import useSelectedDomain from "../../service/Hooks/useSelectedDomain";
import { createValidator, updateValidator, getAllManagerAccounts, getValidationTypes } from "../../service/api/validatorService";
import { toast } from "sonner";
import ValidatorModal from "./ValidatorModal";

const NewValidatorModal = ({ show, onClose, onValidatorCreated, validatorToEdit }) => {
  const [managerAccounts, setManagerAccounts] = useState([]);
  const [validationTypes, setValidationTypes] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const selectedDomain = useSelectedDomain();
  const domainId = selectedDomain?.id;

  useEffect(() => {
    if (show && domainId) {
      const fetchData = async () => {
        try {
          const types = await getValidationTypes();
          const managers = await getAllManagerAccounts(domainId);
          setValidationTypes(types);
          setManagerAccounts(managers);
        } catch (error) {
          toast.error('Erreur de chargement des donnees');
        }
      };
      fetchData();
    }
  }, [show, domainId]);

  const handleSubmit = async (payload) => {
    setIsSubmitting(true);
    try {
      if (validatorToEdit) {
        await updateValidator(validatorToEdit.id, payload);
        toast.success("Validateur modifié avec succès !");
      } else {
        await createValidator(payload);
        toast.success("Validateur créé avec succès !");
      }
      onValidatorCreated();
      onClose();
    } catch (error) {
      toast.error(`Erreur: ${error.response?.data || error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ValidatorModal
      show={show}
      onClose={onClose}
      managerAccounts={managerAccounts}
      validationTypes={validationTypes}
      domainId={domainId}
      validatorToEdit={validatorToEdit}
      isSubmitting={isSubmitting}
      onSubmit={handleSubmit}
    />
  );
};

export default NewValidatorModal;
